import { Component, ViewEncapsulation, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { entAnimations } from 'src/app/animations';
import { ImageService } from 'src/app/services/profile-picture/images.service';
import { UsersService } from 'src/app/services/users/users.service';

export interface ImageDeleteDialogModel {
  userOid: string;
  isSelf: boolean;
  selectedFileUrl: string;
}

@Component({
  selector: 'app-image-delete-dialog',
  templateUrl: './image-delete-dialog.component.html',
  styleUrl: './image-delete-dialog.component.scss',
  encapsulation: ViewEncapsulation.None,
  animations: entAnimations,
  standalone: false,
})
export class ImageDeleteDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ImageDeleteDialogModel,
    private _dialogRef: MatDialogRef<ImageDeleteDialogComponent>,
    private _imageService: ImageService,
    private _userService: UsersService
  ) {}

  // Delete image - self
  deleteImageSelf() {
    this._imageService.setImageUrl(null);
    if (this.data.selectedFileUrl !== null) {
      this._imageService
        .deleteProfilePicture(this.data.userOid)
        .subscribe(error => console.log(error));
      this._userService.updateMyUser(false);
    }
    this.closeDialog(null);
  }

  // Delete image - user
  deleteImage() {
    if (this.data.selectedFileUrl !== null) {
      this._imageService
        .deleteProfilePicture(this.data.userOid)
        .subscribe(error => console.log(error));
      this._userService.updateMyUsers(this.data.userOid, false);
    }
    this.closeDialog(null);
  }

  closeDialog(fileUrl: string | null) {
    this._dialogRef.close(fileUrl);
  }
}
